import { useContext } from 'react'

import { SocketContext } from 'context'

export const useReconnect = () => {
  const { reconnect } = useContext(SocketContext)

  return reconnect
}
